import {
  fetchGuideLesson,
  type GuideLesson,
} from "../../../../../../../../../api/kehrblatt/learning-guide"

/** Load one mounted chapter; completion writes belong to the longer-lived learning workspace. */
export class LessonController {
  lesson = $state<GuideLesson | null>(null)
  loading = $state(true)
  loadError = $state(false)
  private disposed = false
  private read: AbortController | null = null

  constructor(private key: string) {}

  async load() {
    this.read?.abort()
    const controller = new AbortController()
    this.read = controller
    this.loading = true
    this.loadError = false
    try {
      const lesson = await fetchGuideLesson(this.key, { signal: controller.signal })

      if (this.disposed || controller.signal.aborted) return

      this.lesson = lesson
    } catch {
      if (!this.disposed && !controller.signal.aborted) this.loadError = true
    } finally {
      if (!this.disposed && this.read === controller) this.loading = false
    }
  }

  dispose() {
    this.disposed = true
    this.read?.abort()
  }
}
